import { useLiveQuery } from "dexie-react-hooks";
import { ParamRepository } from "../utils/dexie/repositories/param-repository";

export function useApplicationParams() {
    return useLiveQuery(() => ParamRepository.getParams());
}